var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoS = function SvgLogoS(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 322 331"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m252.07 92.729 65.417-66.265C327.128 16.698 320.3 0 306.666 0H160.529zM51.7 160.815c-29.882-30.27-29.882-79.347 0-109.617L102.238.004 270.244 170.19c29.882 30.27 29.882 79.347 0 109.617L219.706 331zM4.513 304.535l65.413-66.262 91.538 92.726H15.334c-13.634 0-20.462-16.698-10.821-26.464",
    clipRule: "evenodd"
  })));
};
export default SvgLogoS;